import { UploadOrgIconClearAction, UploadOrgIconSuccessAction } from "../actions/UploadOrganizationIcon";
import { OrgState } from "../state";

export function clearUploadedOrgIcon(state: OrgState, action: UploadOrgIconClearAction): OrgState {
    return {
        ...state,
        uploadedImages: undefined
    };
}

export function uploadOrgIcon(state: OrgState, action: UploadOrgIconSuccessAction) {
    return {
        ...state,
        uploadedImages: {
            ...state.uploadedImages,
            orgLogo: {
                logoUrl: action.payload.logoUrl
            }
        }
    };
}
